/* Actualización diaria del catálogo, sin que nadie la pida: con la app abierta (la tele que se queda encendida, el ordenador con
   Filoteca en una pestaña), cada 10 minutos se mira si algún proveedor lleva un día sin actualizarse y, si es así, se actualiza
   en segundo plano. Nunca mientras se ve algo ni justo después de tocar la pantalla o el mando. Una app cerrada no puede hacerlo:
   al abrirla se actualiza lo que tenga más de 6 horas (catalog.js). Ajustes → Fuentes → «Actualizar el catálogo cada día». */

export const DAY_MS = 24 * 3600 * 1000;
export const CHECK_MS = 3 * 60000; // cada 3 minutos se mira si algo está pendiente (un catálogo parcial se reintenta a los 3)
export const QUIET_MS = 60000;

/** ¿Toca actualizar? `updatedAt` 0 = no se sabe cuándo: se espera a que se actualice al abrir, no se fuerza. */
export function isDue(updatedAt, now = Date.now(), maxAge = DAY_MS) {
    return !!updatedAt && now - updatedAt >= maxAge;
}

export function startAutoRefresh({ catalog, settings, player } = {}) {
    if (typeof document === 'undefined') return () => {};
    let lastInput = Date.now();
    const touch = () => { lastInput = Date.now(); };
    ['keydown', 'pointerdown', 'touchstart'].forEach((e) => document.addEventListener(e, touch, { passive: true, capture: true }));
    let busy = false;
    const tick = async () => {
        if (busy) return;
        if (!catalog.loaded || (typeof navigator !== 'undefined' && navigator.onLine === false)) return;
        if (player && player.isOpen) return;
        if (Date.now() - lastInput < QUIET_MS) return;
        busy = true;
        // Con la actualización diaria apagada, un catálogo incompleto (algo que el proveedor no contestó) igualmente se reintenta.
        try { await catalog.refreshStale({ maxAgeMs: settings.get('catalogAuto') === false ? Infinity : DAY_MS }); } catch (e) { /* se reintenta en la siguiente vuelta */ } finally { busy = false; }
    };
    const timer = setInterval(tick, CHECK_MS);
    const onVisible = () => { if (!document.hidden) setTimeout(tick, 5000); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(timer); document.removeEventListener('visibilitychange', onVisible); };
}
